import { render } from "./BarreRecherche.vue?vue&type=template&id=fc08d86c&scoped=true"
import script from "./BarreRecherche.vue?vue&type=script&lang=js"
export * from "./BarreRecherche.vue?vue&type=script&lang=js"

import "./BarreRecherche.vue?vue&type=style&index=0&id=fc08d86c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc08d86c"]])

export default __exports__